import * as actions from "../actions";

export const checkStatusUntilFinal = async (popup, onComplete) => {
  const timerMilliSeconds = 5000;
  const interval = setInterval(async () => {
    actions.getKyc().then((data) => {
      const userKyc = data || [];
      const lastKyc = getLastSumsubKYC(userKyc);
      const sumsubApprovedOrAnalyzing = isSumsubApprovedOrAnalyzing(lastKyc);
      if (sumsubApprovedOrAnalyzing) {
        clearInterval(interval);
        if (onComplete) {
          onComplete();
        }
        setTimeout(() => popup.close(), timerMilliSeconds * 2);
      }
    });
  }, timerMilliSeconds);
};

export const getLastSumsubKYC = (userKyc) => {
  return (userKyc || [])
    .filter((kyc) => kyc.documentType === "SUMSUB")
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))?.[0];
};

export const isSumsubApprovedOrAnalyzing = (kyc) => {
  if (!kyc) {
    return false;
  }
  return (
    kyc?.status.toLowerCase() === "approved" ||
    kyc?.status.toLowerCase() === "analyzing"
  );
};

export const isOldKycApproved = ({ isPj, userKyc }) => {
  
  if (!userKyc) return false;
  
  const byDocuments = {
    ID: userKyc?.filter((kyc) => kyc.documentType === "ID").sort((a, b) => new Date(b.statusDate) - new Date(a.statusDate))?.[0],
    ID_WITH_PHOTO: userKyc?.filter((kyc) => kyc.documentType === "ID_WITH_PHOTO").sort((a, b) => new Date(b.statusDate) - new Date(a.statusDate))?.[0],
  };

  if (isPj) {
    byDocuments.SOCIAL_CONTRACT = userKyc.filter((kyc) => kyc.documentType === "SOCIAL_CONTRACT").sort((a, b) => new Date(b.statusDate) - new Date(a.statusDate))?.[0];
  } else {
    byDocuments.ADDRESS = userKyc.filter((kyc) => kyc.documentType === "ADDRESS").sort((a, b) => new Date(b.statusDate) - new Date(a.statusDate))?.[0];
  }

  const kycHaveBeenApproved = Object.values(byDocuments).every((doc) => doc?.status === "APPROVED");
  return kycHaveBeenApproved;
};